"use strict";

require("core-js/modules/es.reflect.construct.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _commonComponents = require("../commonComponents");

var _formElements = require("@evidation/form-elements");

var _react = _interopRequireWildcard(require("react"));

var _reactSignatureCanvas = _interopRequireDefault(require("react-signature-canvas"));

var _utils = require("./utils");

var _reactI18next = require("react-i18next");

var _LanguageContext = require("../contexts/LanguageContext");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SignaturePad = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(SignaturePad, _PureComponent);

  var _super = _createSuper(SignaturePad);

  function SignaturePad(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, SignaturePad);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (signature) {
      _this.setState({
        signature: signature
      }, function () {
        _this.props.input.onChange(signature);
      });
    });
    _this.state = {
      signature: ""
    };
    return _this;
  }

  (0, _createClass2["default"])(SignaturePad, [{
    key: "clearCanvas",
    value: function clearCanvas() {
      var _this2 = this;

      this.setState({
        signature: ""
      }, function () {
        return _this2.sigCanvas.clear();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var signature = this.state.signature;
      var _this$props = this.props,
          labelStyle = _this$props.labelStyle,
          label = _this$props.label,
          _this$props$config$st = _this$props.config.style,
          style = _this$props$config$st === void 0 ? {} : _this$props$config$st,
          t = _this$props.t;
      return /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
        labelStyle: labelStyle,
        label: "".concat(label),
        className: "datepicker ".concat((0, _utils.constructFieldClassname)(this.props.meta))
      }, /*#__PURE__*/_react["default"].createElement(_commonComponents.PadHolder, {
        style: style
      }, /*#__PURE__*/_react["default"].createElement(_reactSignatureCanvas["default"], {
        ref: function ref(_ref) {
          _this3.sigCanvas = _ref;
        },
        onEnd: function onEnd() {
          return _this3.onChange(_this3.sigCanvas.getTrimmedCanvas().toDataURL('image/png'));
        }
      })), /*#__PURE__*/_react["default"].createElement(_commonComponents.AddButton, {
        disabled: signature === "",
        onClick: function onClick() {
          return _this3.clearCanvas();
        }
      }, t('common.clear')));
    }
  }]);
  return SignaturePad;
}(_react.PureComponent);

var _default = (0, _reactI18next.withTranslation)(_LanguageContext.curiousPandaNamespace)(SignaturePad);

exports["default"] = _default;